function EmptyPanorama() {
	return (
		<group>
			<mesh>
				<sphereBufferGeometry args={[500, 20, 20]} />
				<meshBasicMaterial color={0x000000} wireframe={true} />
			</mesh>
		</group>
	);
}

export default EmptyPanorama;
